<template>
  <v-form
    v-if="draft"
    v-model="isValid"
  >
    <v-card>
      <v-card-title primary-title>
        <div>
          <v-layout
            row
            align-center
          >
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                small
                icon
                class="ma-0"
                @click="$router.go(-1)"
              >
                <v-icon color="grey darken-1">
                  arrow_back
                </v-icon>
              </v-btn>
              <span>Назад</span>
            </v-tooltip>
            <h3 class="headline mb-0">
              Черновик для клиента {{ draft.Title }}
            </h3>
          </v-layout>
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <app-reference
              v-model="draft.Data.ManagerEntity"
              class="mx-2 my-0"
              label="Менеджер*"
              resource="employees"
              component-name="Employee"
              :rules="commonRules"
              @input="managerChosen"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Title"
              class="mx-2 my-0"
              label="Название фирмы*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.City"
              class="mx-2 my-0"
              label="Город*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.ActivityType"
              class="mx-2 my-0"
              label="Род деятельности"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.Phone"
              class="mx-2 my-0"
              label="Корпоративный телефон"
              hide-details
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="draft.Data.Email"
              class="mx-2 my-0"
              label="Корпоративный e-mail"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.WebSite"
              class="mx-2 my-0"
              label="Сайт"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.OwnerLastName"
              class="mx-2 my-0"
              label="Владелец Фамилия"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.OwnerFirstName"
              class="mx-2 my-0"
              label="Владелец Имя"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.OwnerPhone"
              class="mx-2 my-0"
              label="Телефон владельца"
              hide-details
              mask="+##(###)###-##-## *#####"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="draft.Data.OwnerEmail"
              class="mx-2 my-0"
              label="E-mail владельца"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.DirectorLastName"
              class="mx-2 my-0"
              label="Руководитель Фамилия"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.DirectorFirstName"
              class="mx-2 my-0"
              label="Руководитель Имя"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.DirectorPhone"
              class="mx-2 my-0"
              label="Телефон руководителя"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.DirectorEmail"
              class="mx-2 my-0"
              label="E-mail руководителя"
              hide-details
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="draft.Data.ContactPersonLastName"
              class="mx-2 my-0"
              label="Контактное лицо Фамилия*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.ContactPersonFirstName"
              class="mx-2 my-0"
              label="Контактное лицо Имя*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.ContactPersonPosition"
              class="mx-2 my-0"
              label="Должность"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.ContactPersonPhone"
              class="mx-2 my-0"
              label="Контактный телефон*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.ContactPersonEmail"
              class="mx-2 my-0"
              label="Контактный e-mail*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="draft.Data.AddressPostcode"
              class="mx-2 my-0"
              label="Индекс*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.AddressCountry"
              class="mx-2 my-0"
              label="Страна*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.AddressCity"
              class="mx-2 my-0"
              label="Город*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.AddressRegion"
              class="mx-2 my-0"
              label="Регион*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.AddressStreet"
              class="mx-2 my-0"
              label="Улица*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="draft.Data.AddressBuildNumber"
              class="mx-2 my-0"
              label="Дом*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.Aliases"
              class="mx-2 my-0"
              label="Названия клиента на фабриках(если несколько,через ';')"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.Referral"
              class="mx-2 my-0"
              label="Реферал"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.Category"
              class="mx-2 my-0"
              label="Категория клиента*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="draft.Data.Notes"
              class="mx-2 my-0"
              label="Нюансы взаимодействия, специфика"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          small
          color="primary"
          @click="save"
        >
          Сохранить
        </v-btn>
        <v-btn
          small
          @click="$router.go(-1)"
        >
          Отмена
        </v-btn>
        <v-spacer />
        <v-btn
          small
          color="error"
          @click="remove"
        >
          {{ "Удалить" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import * as importApi from "../../../backend/importApi.js";

export default {
  props: ["id"],
  data() {
    return {
      draft: null,
      isValid: false,
      commonRules: [v => !!v || ""],
      manager: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await importApi.getClientDraft(this.id);
      this.draft = res.data;
      this.draft.Data.Aliases = this.draft.Data.Aliases.join(";");
      if (this.draft.Data.ManagerEntity) {
        this.draft.Data.ManagerEntity = {
          id: res.data.Data.ManagerEntity.Id,
          title: res.data.Data.ManagerEntity.Title,
        };
      }
    },
    async save() {
      this.draft.Data.Aliases = this.draft.Data.Aliases.split(";");
      await importApi.createClientDraft(this.id, this.draft);
      this.showInfo("Сохранено");
      this.$router.go(-1);
    },
    async remove() {
      await importApi.deleteClientDraft(this.id);
      this.showInfo("Черновик удален");
      this.$router.go(-1);
    },
    managerChosen(chosenManager) {
      if (chosenManager) {
        this.draft.Data.Manager = chosenManager.title.split(" ")[0];
      }
    },
  },
};
</script>
